<div class="onboarding-content">
    <kendo-loader *ngIf="isSaving" [type]="'infinite-spinner'" [loading]="isSaving"></kendo-loader>

    <div class="component-block">
      <h2>Tell us about your organization</h2>
      <p class="info">This information will help us set up your account.</p>
      <form>
        <div class="input-wrapper">
          <label>Organization Name</label>
          <input kendoTextBox [(ngModel)]="organization.Name" name="organizationName" (ngModelChange)="validateName()">
          <span *ngIf="this.organization.Name.length == 0" class="error">An organization name is required</span>
        </div>
        <div class="input-wrapper">
          <label>Address</label>
          <input kendoTextBox [(ngModel)]="organization.Address" name="address" (ngModelChange)="onFieldChange()">
        </div>
        <div class="input-wrapper">
          <label>Country</label>
          <input kendoTextBox [(ngModel)]="organization.Country" name="country" (ngModelChange)="onFieldChange()">
        </div>
        <div class="input-wrapper">
          <label>City</label>
          <input type="text" class="input-field"kendoTextBox [(ngModel)]="organization.City" name="city" (ngModelChange)="onFieldChange()">
        </div>
        <div class="input-wrapper">
          <label>State</label>
          <input kendoTextBox [(ngModel)]="organization.State" name="state" (ngModelChange)="onFieldChange()">
        </div>
        <div class="input-wrapper">
          <label>Postal Code</label>
          <input kendoTextBox [(ngModel)]="organization.PostalCode" name="postalCode" (ngModelChange)="onFieldChange()">
        </div>
        <div class="input-wrapper">
          <label>Phone Number</label>
          <input kendoTextBox [(ngModel)]="organization.Phone" name="organizationPhone" (ngModelChange)="onFieldChange(); validatePhone()">
          <span *ngIf="!isPhoneValid" class="error">Invalid phone number format.</span>
        </div>
        <div class="btn-group">
          <button kendoButton [disabled]="!hasChanges || !isPhoneValid" (click)="continue()" type="submit">Continue</button>
          <button kendoButton look="outline" (click)="onBack()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
  